import React, { useEffect, useRef, useState } from "react";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ProductSize from "../ProductSize/ProductSize";
import ClothColor from "../ClothColor/ClothColor";
import Button from "../Button/Button";
import Divider from "@mui/material/Divider";
import { apiBaseUrl } from "../../config";
import { getSizeChart } from "../../reducer/commonValuesSlice";
import { useDispatch, useSelector } from "react-redux";
import { getDomainInfo, isVideo } from "../../utils/utils";
import sizechart from "../../assets/images/no-image-available.jpg";
import _ from "lodash";
import addItemToTheCart from "../../services/Cart";
import { getCartInfo } from "../../reducer/userCartSlice";
import VariantList from "../VariantList";
import { Alert, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { CiCircleMinus } from "react-icons/ci";
import { CiCirclePlus } from "react-icons/ci";
import ImgOrVideo from "../ImgOrVideo";
import { toast } from "react-toastify";

const drawerBleeding = 49;

const Root = styled("div")(() => ({
  height: "100%",
  backgroundColor: grey[100],
}));

const StyledBox = styled("div")(() => ({
  backgroundColor: "#fff",
}));

let TOAST_ID = "no-inventory-toast";

const CommonDrawer = ({ isOpen, onClose, product }) => {



  // console.log(product)
  const drawerRef = useRef(null);
  const [selectedSize, setSelectedSize] = useState("M"); // Default size
  const [selectedColor, setSelectedColor] = useState("NavyBlue"); // Default color
  const [imageIndex, setImageIndex] = useState(0); // Track color index
  const [isLoading, setIsLoading] = useState(false);
  const [productDetails, setProductDetails] = useState();
  const dispatch = useDispatch();
  const [productAttributes, setProductAttributes] = useState();
  const [ProductVariantLength, setProductVariantLength] = useState();
  const [isVarient, setisvarient] = useState(false);
  const [constItemDetails, setConstItemDetails] = useState({
    title: "",
    des: "",
    img: [],
  });
  const [adding, setAdding] = useState(false)

  const [selectedVariantValues, setSelectedVariantValues] = useState({});
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [isProductInCart, setIsProductInCart] = useState(false);
  const cartItems =
    useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
  let token = localStorage.getItem("token");
  const cartContext = localStorage.getItem("cartContext");
  const customerId = localStorage.getItem("customerId");
  const [indexOne, setIndexone] = useState(null);
  const [indexTwo, setIndextwo] = useState(null);
  const [dynamicIds, setDynamicIds] = useState({});
  const [variantlength, setvariantlength] = useState(0);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { userId } = useParams();
  const { isPredefinedDomain, uid } = getDomainInfo(userId);
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const [count, setCount] = useState(1);
  const [selectedStock, setSelectedStock] = useState(null);

  const handlegoToCart = () => {
    navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
    setTimeout(() => window.location.reload(), 100);
  };
  // console.log(indexOne,indexTwo)
  const incrementHandler = async () => {
    try {
      const variant1Id = indexOne;
      const variant2Id = indexTwo;

      // Fetch the most recent stock from DB
      const params = new URLSearchParams({ productId: productDetails.id });
      if (variant1Id) params.append("variant1Id", variant1Id);
      if (variant2Id) params.append("variant2Id", variant2Id);

      const res = await fetch(`${apiBaseUrl}product/get-live-stock?${params.toString()}`);
      const data = await res.json();
      const liveStock = data.stock || 0;

      if (count >= liveStock) {
        // toast.warn(`No more inventory ${liveStock} left`, { position: "top-center", autoClose: 2000 });

        if (!toast.isActive(TOAST_ID)) {
            toast.warn(`No more inventory ${liveStock} left`, { toastId: TOAST_ID, position: "top-center", autoClose: 2000 });
          } else {
            toast.update(TOAST_ID, {
              render: `No more inventory ${liveStock} left`,
              autoClose: 2000,
            });
          }

        return;
      }

      const newCount = count + 1;
      setCount(newCount);

      if (isProductInCart) {
        const variant =
          selectedVariantValues && Object.entries(selectedVariantValues).length > 0
            ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
              const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
              acc[variantKey] = { title: value };
              return acc;
            }, {})
            : null;

        await updateProductQuantity(newCount, productDetails.id, variant);
      }
    } catch (err) {
      console.error("Error incrementing quantity:", err);
    }
  };

  const decrementHandler = async () => {
    if (count <= 1) return;

    try {
      const variant1Id = indexOne;
      const variant2Id = indexTwo;

      // ✅ Fetch the most recent stock from DB
      const params = new URLSearchParams({ productId: productDetails.id });
      if (variant1Id) params.append("variant1Id", variant1Id);
      if (variant2Id) params.append("variant2Id", variant2Id);

      const res = await fetch(`${apiBaseUrl}product/get-live-stock?${params.toString()}`);
      const data = await res.json();
      const liveStock = data.stock || 0;

      // 🔁 If current count > stock (maybe stock was reduced), reset and show toast
      if (count > liveStock) {
        toast.warn(`Product Sold Out. Only ${liveStock} item${liveStock !== 1 ? 's' : ''} left.`, {
          position: "top-center",
          autoClose: 2000,
        });
        setCount(liveStock);
        return;
      }

      const newCount = count - 1;
      setCount(newCount);

      if (isProductInCart) {
        const variant =
          selectedVariantValues && Object.entries(selectedVariantValues).length > 0
            ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
              const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
              acc[variantKey] = { title: value };
              return acc;
            }, {})
            : null;

        await updateProductQuantity(newCount, productDetails.id, variant);
      }
    } catch (err) {
      console.error("Decrement error:", err);
    }
  };


  useEffect(() => {
    if (isOpen && drawerRef.current) {
      drawerRef.current.scrollTop = drawerRef.current.scrollHeight;
    }
  }, [isOpen]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

    useEffect(() => {
      if (!productDetails) return;
  
      let retries = 10;
  
      const interval = setInterval(() => {
        if (window.fbq && typeof window.fbq === 'function') {
          console.log("✅ ViewContent fired:", productDetails);
  
          window.fbq('track', 'ViewContent', {
            content_name: productDetails.title,
            content_ids: [
              isVarient && selectedVariantValues?.sku_id
                ? selectedVariantValues.sku_id
                : productDetails?.skuId
            ],
            content_type: 'product',
            value: productDetails.price,
            currency: 'INR'
          });
  
          clearInterval(interval);
        } else {
          console.log(`⏳ Waiting for fbq... retries left: ${retries}`);
          retries--;
          if (retries <= 0) {
            console.warn("❌ fbq not ready, ViewContent NOT fired.");
            clearInterval(interval);
          }
        }
      }, 300);
  
      return () => clearInterval(interval);
  
    }, [productDetails]);

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleNextColor = () => {
    const filteredImages = getFilteredImages();
    if (filteredImages.length > 1) {
      setImageIndex((prevIndex) => (prevIndex + 1) % filteredImages.length);
    }
  };

  const handlePrevColor = () => {
    const filteredImages = getFilteredImages();
    if (filteredImages.length > 1) {
      setImageIndex((prevIndex) => (prevIndex - 1 + filteredImages.length) % filteredImages.length);
    }
  };

  useEffect(() => {
    if (isOpen && product?.id && userid) {
      setProductDetails(null);
      setSelectedVariant(null);
      setSelectedVariantValues({});
      setSelectedStock(null);
      fetchProductDetails();
    }
  }, [isOpen, product?.id, userid]);

  useEffect(() => {
    if (productDetails) {
      const productVariants = productDetails?.additionalInfo?.productVariants;
      const firstProductVariants = productVariants?.[0]?.variants || [];
      const uniqueVariants = firstProductVariants.filter(
        (variant, index, self) =>
          index === self.findIndex((v) => v.value._id === variant.value._id)
      );
      setvariantlength(uniqueVariants.length);
    }
  }, [productDetails]);

  const onVariantSelect = (selectedValues) => {
    setSelectedVariantValues(selectedValues);

    // Find the matching variant combination
    if (productDetails?.additionalInfo?.productVariants) {
      const matchingVariant = productDetails.additionalInfo.productVariants.find(
        (variant) =>
          variant.variants.every(
            (v) => selectedValues[v.title]?.id === v.value._id
          )
      );

      if (matchingVariant) {
        setSelectedVariant(matchingVariant);
        setSelectedStock(matchingVariant.stock);
      } else {
        setSelectedStock(null);
      }
    }
  };

  useEffect(() => {
    if (productDetails) {
      setConstItemDetails({
        title: productDetails?.title,
        des: productDetails?.description,
        img: productDetails?.images,
      });
    }
  }, [productDetails]);

  // const updateState = () => {



  //   const newDynamicIds = Object.entries(selectedVariantValues).reduce(
  //     (acc, [key, value]) => {
  //       acc[key] = value?.id;
  //       return acc;
  //     },
  //     {}
  //   );
  //   setDynamicIds((prev) => {
  //     const isSame = Object.keys(newDynamicIds).every(
  //       (key) => prev[key] === newDynamicIds[key]
  //     );
  //     return isSame ? prev : newDynamicIds;
  //   });


  // };
  const updateState = () => {
    const entries = Object.entries(selectedVariantValues);

    if (entries.length === 0) {
      setIndexone(null)
      setIndextwo(null)
    }

    const newDynamicIds = (() => {
      // If only one value is selected
      if (entries.length === 1) {
        const [onlyKey, onlyValue] = entries[0];
        return Object.keys(dynamicIds).reduce((acc, key) => {
          acc[key] = key === onlyKey ? onlyValue?.id : null;
          setIndextwo(null)

          return acc;
        }, {});

      }

      // If multiple values are selected
      return entries.reduce((acc, [key, value]) => {
        acc[key] = value?.id;
        return acc;
      }, {});
    })();
    setDynamicIds((prev) => {
      const isSame = Object.keys(newDynamicIds).every(
        (key) => prev[key] === newDynamicIds[key]
      );
      return isSame ? prev : newDynamicIds;
    });
  };

  useEffect(() => {
    updateState();
  }, [selectedVariantValues, variantlength]);

  useEffect(() => {
    if (dynamicIds[Object.keys(dynamicIds)[0]]) {
      setIndexone(dynamicIds[Object.keys(dynamicIds)[0]]);
    }
    if (dynamicIds[Object.keys(dynamicIds)[1]]) {
      setIndextwo(dynamicIds[Object.keys(dynamicIds)[1]]);
    }
  }, [dynamicIds]);

  const getFilteredImages = () => {
    if (selectedVariant && selectedVariant.images && selectedVariant.images.length > 0) {
      return selectedVariant.images;
    }

    if (
      !productDetails?.additionalInfo?.productVariants ||
      !selectedVariantValues
    ) {
      return constItemDetails?.img || [];
    }

    // Find the matching variant combination
    const matchingVariant = productDetails.additionalInfo.productVariants.find(
      (variant) =>
        variant.variants.every(
          (v) => selectedVariantValues[v.title]?.id === v.value._id
        )
    );

    // Return the images of the matching variant or default images
    return matchingVariant?.images || constItemDetails?.img || [];
  };

  // Check if product is already in cart
  useEffect(() => {
    if (!productDetails?.id || !cartItems?.length) return;

    const pid = productDetails.id;

    const variantObject = selectedVariantValues
      ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
        const keyName = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
        acc[keyName] = { title: value };
        return acc;
      }, {})
      : {};

    let matchedItem = null;

    for (const item of cartItems) {
      const itemId = item?.productId || item?.id;

      if (itemId !== pid) continue;

      // Simple product (no variants)
      if (variantlength === 0) {
        matchedItem = item;
        break;
      }

      // Variant match
      if (item.variant && Object.keys(item.variant).length > 0) {
        const varintid1 = item.variant.firstVariant?.title?.id;
        const objectid1 = variantObject.firstVariant?.title?.id;

        const varintid2 = item.variant.secondVariant?.title?.id;
        const objectid2 = variantObject.secondVariant?.title?.id;
        let isMatch = false;
        if(varintid2 && objectid2){
          isMatch = _.isEqual(varintid1, objectid1) && _.isEqual(varintid2, objectid2);
        }
        else{
          isMatch = _.isEqual(varintid1, objectid1);
        }
        if (isMatch) {
          matchedItem = item;
          break;
        }
      }
    }

    if (matchedItem) {
      setIsProductInCart(true);
      setCount(matchedItem.quantity || 1);
    } else {
      setIsProductInCart(false);
      setCount(1);
    }
  }, [
    productDetails?.id,
    cartItems,
    selectedVariantValues,
    indexOne,
    indexTwo,
    variantlength
  ]);

  // const handleGoToCart = () => {
  //   if (token) {
  //     // User is logged in, redirect to cart
  //     navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
  //   } else {
  //     // User is not logged in, redirect to login
  //     navigate(isPredefinedDomain ? `/${uid}/login` : "/login");
  //   }
  // };


  //   const handleAddToCart = (buyItNow) => {
  // if(adding) return
  //     setAdding(true)
  //     if (isVarient && selectedStock === 0) {
  //       setOpen(true);
  //       return;
  //     }

  //     const variantImage = getFilteredImages();
  //     const isVideoProduct = variantImage[0] && isVideo(variantImage[0]);
  //     const productImage = isVideoProduct ? sizechart : variantImage[0];

  //     const variant = selectedVariantValues
  //       ? Object.entries(selectedVariantValues).reduce(
  //           (acc, [key, value], index) => {
  //             const variantKey =
  //               index === 0
  //                 ? "firstVariant"
  //                 : index === 1
  //                 ? "secondVariant"
  //                 : `variant${index + 1}`;
  //             acc[variantKey] = { title: value };
  //             return acc;
  //           },
  //           {}
  //         )
  //       : null;

  //     // Get the correct price based on variant selection
  //     let price;
  //     let mrp;

  //     if (selectedVariant) {
  //       price = selectedVariant?.price;
  //       mrp = selectedVariant?.mrp;
  //     } else if (isVarient && selectedVariantValues) {
  //       price = selectedVariantValues?.price;
  //       mrp = selectedVariantValues?.mrp;
  //     } else {
  //       price = productDetails?.price;
  //       mrp = productDetails?.mrp;
  //     }

  //     // Fallback if price is null, undefined, or 0
  //     if (!price || price === 0) {
  //       price = mrp;
  //     }


  //     const productData = {
  //       id: productDetails?.id,
  //       title: productDetails?.title,
  //       price: price === 0 ? mrp : price,
  //       mrp: mrp,
  //       image:
  //           isVarient === true
  //             ? selectedVariantValues?.images?.length > 0
  //               ? selectedVariantValues?.images[0]
  //               : productImage
  //             : productImage,
  //       quantity: count,
  //       storeid: userid,
  //       variant: variant,
  //     };

  //     // Check if all required variants are selected
  //     if (isVarient && productDetails?.additionalInfo?.productVariants?.length > 0) {
  //       const requiredVariants = productDetails.additionalInfo.productVariants[0].variants;
  //       const missingVariants = requiredVariants.filter(
  //         (v) => !selectedVariantValues[v.title]
  //       );

  //       if (missingVariants.length > 0) {
  //         setOpen(true);
  //         return;
  //       }
  //     }

  //     const productExists = cartItems.some((item) => {
  //       if (item.id === productData.id) {
  //         if (
  //           productData.variant &&
  //           Object.keys(productData.variant).length !== 0
  //         ) {
  //           if (
  //             item.variant &&
  //             Object.keys(item.variant).length !== 0 &&
  //             _.isEqual(item.variant, productData.variant)
  //           ) {
  //             return true;
  //           }
  //         } else {
  //           return true;
  //         }
  //       }
  //       return false;
  //     });

  //     if (productExists) {
  //       let filterCartItem = cartItems.filter((item) => {
  //         if (item.productId === productData.id) {
  //           if (
  //             productData.variant &&
  //             Object.keys(productData.variant).length !== 0
  //           ) {
  //             if (
  //               item.variant &&
  //               Object.keys(item.variant).length !== 0 &&
  //               _.isEqual(item.variant, productData.variant)
  //             ) {
  //               return item;
  //             }
  //           } else {
  //             return item;
  //           }
  //         }
  //         return false;
  //       });
  //       if (filterCartItem.length > 0) {
  //         const item = filterCartItem[0];
  //         const productId = item?.productId;
  //         const quantity = item?.quantity;
  //         if (productId && quantity) {
  //           let updatedQuantity = quantity + count;
  //           updateProductQuantity(updatedQuantity, productId, variant).then(
  //             (cartItems) => {
  //               if (cartItems) {
  //                 setOpen(true);
  //                 if (buyItNow === true) {
  //                   navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
  //                 }
  //               }
  //             },
  //             (error) => {
  //               console.error(
  //                 `error occurred while updating the item quantity in cart: ${error}`
  //               );
  //             }
  //           );
  //         }
  //       }
  //     } else {
  //       addItemToTheCart(productData, count).then(
  //         (data) => {
  //           if (data) {
  //             dispatch(getCartInfo(data?.cart));
  //             setOpen(true);
  //             if (buyItNow === true) {
  //               navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
  //             }
  //           }
  //         },
  //         (error) => {
  //           console.error(
  //             `error occurred while adding item to the cart: ${error}`
  //           );
  //         }
  //       );
  //     }


  // setAdding(false)

  //   };


  const handleAddToCart = async (buyItNow) => {
    if (adding) return;
    setAdding(true);

    try {
      const variantImages = getFilteredImages();
      const isVideoProduct = variantImages[0] && isVideo(variantImages[0]);
      const productImage = isVideoProduct ? sizechart : variantImages[0];

      const variant = selectedVariantValues
        ? Object.entries(selectedVariantValues).reduce(
          (acc, [key, value], index) => {
            const variantKey =
              index === 0
                ? "firstVariant"
                : index === 1
                  ? "secondVariant"
                  : `variant${index + 1}`;
            acc[variantKey] = { title: value };
            return acc;
          },
          {}
        )
        : null;

      // Validate variant selections
      if (
        isVarient &&
        productDetails?.additionalInfo?.productVariants?.length > 0
      ) {
        const requiredVariants =
          productDetails.additionalInfo.productVariants[0].variants;
        const missing = requiredVariants.filter(
          (v) => !selectedVariantValues[v.title]
        );
        if (missing.length > 0) {
          setOpen(true);
          return;
        }
      }

      // 🟡 Fetch latest stock + price + mrp before adding
      const params = new URLSearchParams({ productId: productDetails.id });
      if (indexOne) params.append("variant1Id", indexOne);
      if (indexTwo) params.append("variant2Id", indexTwo);
      const res = await fetch(`${apiBaseUrl}product/get-live-stock?${params.toString()}`);
      const data = await res.json();

      const latestStock = data.stock || 0;
      const latestPrice = data.price;
      const latestMrp = data.mrp;

      let price = selectedVariant?.price ?? selectedVariantValues?.price ?? productDetails?.price;
      let mrp = selectedVariant?.mrp ?? selectedVariantValues?.mrp ?? productDetails?.mrp;

      // if (price !== latestPrice) {
      //   toast.info(`Price updated by the seller for this product ₹${latestPrice}`, {
      //     position: "top-center",
      //     autoClose: 3000,
      //   });
      // }

      // if (!latestPrice || latestPrice === 0) price = latestMrp;
      // else price = latestPrice;

      // mrp = latestMrp;

      if (price !== latestPrice || mrp !== latestMrp) {
        toast.info(`Price updated by the seller to ₹${latestPrice}`, {
          position: "top-center",
          autoClose: 3000,
        });

        if (isVarient) {
          // For variant products, update selectedVariant to trigger re-render
          const matchingVariant = productDetails?.additionalInfo?.productVariants?.find(
            (variant) =>
              variant.variants.every(
                (v) => selectedVariantValues[v.title]?.id === v.value._id
              )
          );
          if (matchingVariant) {
            matchingVariant.price = latestPrice;
            matchingVariant.mrp = latestMrp;
            setSelectedVariant({ ...matchingVariant });
          }
        } else {
          // For non-variant products, update productDetails to reflect new price
          setProductDetails((prev) => ({
            ...prev,
            price: latestPrice,
            mrp: latestMrp,
          }));
        }
      }

      const productData = {
        id: productDetails?.id,
        title: productDetails?.title,
        price: latestPrice === 0 ? latestMrp : latestPrice,
        mrp: latestMrp,
        image:
          isVarient === true
            ? selectedVariantValues?.images?.[0] || productImage
            : productImage,
        quantity: count,
        storeid: userid,
        variant: variant,
        stock: isVarient ? latestStock : productDetails?.stock,
      };

      const findMatchingCartItem = (cartItems, productData) => {
        return cartItems.find((item) => {
          const itemId = item.productId || item.id;
          if (itemId !== productData.id) return false;

          if (productData.variant && Object.keys(productData.variant).length > 0) {
            return (
              item.variant &&
              Object.keys(item.variant).length > 0 &&
              _.isEqual(item.variant, productData.variant)
            );
          }

          return !item.variant || Object.keys(item.variant).length === 0;
        });
      };

      const existingItem = findMatchingCartItem(cartItems, productData);

      if (existingItem) {
        const updatedQuantity = existingItem.quantity + count;
        const productId = existingItem.productId || existingItem.id;

        await updateProductQuantity(updatedQuantity, productId, variant);
        setOpen(true);
        if (buyItNow === true) {
          navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
          setTimeout(() => window.location.reload(), 100);
        }
      } else {
        const data = await addItemToTheCart(productData, count);
        if (data) {
          dispatch(getCartInfo(data?.cart));
          setOpen(true);
          if (buyItNow === true) {
            navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
            setTimeout(() => window.location.reload(), 100);
          }
        }
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      setAdding(false);
    }
  };



  const buyItNow = () => {
    handleAddToCart(true);
  };

  /**
   * This method is used to update cart length and show success model for add to cart
   * @param updatedCart
   */
  const updateCartLengthAndShowModal = () => {
    const addCartModal = new window.bootstrap.Modal(
      document.getElementById("addCart")
    );
    addCartModal.show();

    const modalElement = document.getElementById("addCart");
    const handleModalCleanup = () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";

      const backdropElement = document.querySelector(".modal-backdrop");
      if (backdropElement) {
        backdropElement.remove();
      }

      modalElement.removeEventListener("hidden.bs.modal", handleModalCleanup);
    };

    modalElement.addEventListener("hidden.bs.modal", handleModalCleanup);
  };

  /**
   * This method is used to update product quantity
   * @param quantity
   * @param productId
   * @returns {Promise<unknown>}
   */
  const updateProductQuantity = async (quantity, productId, variant) => {
    return new Promise(async (resolve, reject) => {
      try {
        let headers = {
          "Content-Type": "application/json",
        };
        if (token) {
          headers["token"] = token;
        }
        const response = await fetch(
          `${apiBaseUrl}cart/update-item-quantity-in-cart`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              storeid: userid,
              id: productId,
              quantity: quantity,
              variant: variant,
              cartContext: cartContext,
              customerId: customerId,
            }),
          }
        );
        const data = await response.json();
        dispatch(getCartInfo(data?.cart));
        resolve(data?.cart?.cartItem);
      } catch (e) {
        console.error("error while updating the quantity of product");
        reject(e);
      }
    });
  };
  const fetchProductDetails = async () => {
    if (!userid || !product?.id) {
      console.error("Error: userid or product.id is undefined!");
      return;
    }

    setIsLoading(true);
    try {
      const url = `${apiBaseUrl}user/get-seller-product-details/${userid}/${product.id}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const data = await response.json();

      if (data?.product) {
        setProductDetails(data.product);
        dispatch(getSizeChart(data.product.sizeChart));
        setProductAttributes(data.product.additionalInfo?.attributes);
        setProductVariantLength(data.product.additionalInfo?.productVariants);
        setisvarient(data.product.additionalInfo?.productVariants.length > 0);
      } else {
        console.warn("Warning: Product data is missing in API response.");
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Check if current selection is out of stock
  const isOutOfStock = () => {
    if (isVarient) {
      // For variant products, check the selected variant's stock
      return selectedStock === 0;
    } else {
      // For non-variant products, check the main product stock
      return productDetails?.stock === 0;
    }
  };

  const isIncrementDisabled = () => {
    return count >= selectedStock;
  };


  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: "auto",
            maxHeight: "150vh", maxWidth: "393px", margin: "auto",
            overflow: "hidden",
          },
        }}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {isProductInCart ? "Item updated in cart successfully" : "Item added to cart successfully"}
        </Alert>
      </Snackbar>

      <SwipeableDrawer className="cartDrawer-modal-box"
        anchor="bottom"
        open={isOpen}
        onClose={onClose}
        onOpen={() => { }}
        autoPlay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <StyledBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px 12px",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px", border: '1px solid #DBDBDB',
            backgroundColor: "#fff",
            position: "relative",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              flex: 1,
              textAlign: "center",
              mt: 1,
            }}
            className="drawerMainTitle"
          >
            CHOOSE OPTIONS
          </Typography>
          <Typography
            sx={{
              position: "absolute",
              right: "12px",
              fontSize: "18px",
              cursor: "pointer",
              mt: 1,
            }}
            onClick={onClose}
          >
            ✕
          </Typography>
        </StyledBox>

        <Divider className="divider" />

        {/* Scrollable Content */}
        <StyledBox
          ref={drawerRef}
          sx={{
            maxHeight: "calc(80vh - 50px)",
            overflowY: "auto",
          }}
          className="drawer-image-slide-parent"
        >
          {product ? (
            <>
              {/* Product Image with Navigation */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  mt: 2, width: '100%',
                }}
                className="drawer-image-slide-child"
              >
                {/* Left Button */}
                <button
                  onClick={handlePrevColor}
                  disabled={getFilteredImages().length <= 1}
                  style={{
                    position: "absolute",
                    left: 0,
                    height: "40px",
                    border: "none",
                    background: "none",
                    fontSize: "24px",
                    color: getFilteredImages().length > 1 ? "black" : "grey",
                    cursor:
                      getFilteredImages().length > 1 ? "pointer" : "not-allowed",
                  }}
                >
                  <IoIosArrowBack />

                </button>

                {/* Product Image or Video (changes with size & color) */}
                <ImgOrVideo
                  key={imageIndex}
                  url={getFilteredImages()[imageIndex]}
                  uid={uid}
                  type={1}
                  productName={constItemDetails?.title}
                />

                {/* Right Button */}
                <button
                  onClick={handleNextColor}
                  disabled={getFilteredImages().length <= 1}
                  style={{
                    position: "absolute",
                    right: 0, transform: "translateY(-50%)", top: "50%",
                    height: "40px",
                    border: "none",
                    background: "none",
                    fontSize: "24px",
                    color: getFilteredImages().length > 1 ? "black" : "grey",
                    cursor:
                      getFilteredImages().length > 1 ? "pointer" : "not-allowed",
                  }}
                >
                  <IoIosArrowForward />

                </button>
              </Box>

              {/* Product Name */}
              <Typography
                className="drawerheading fontclass drawerTitle"
                sx={{
                  textAlign: "center",
                  mt: 2,
                  fontSize: 20,
                  color: "#403234",
                }}
              >
                {product.title}
              </Typography>

              {/* Price Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  mt: 1,
                }}
              >
                <Typography
                  variant="body1"
                  color="black"
                  className={"fontclass drawerPrice"}
                >
                  &#8377; {
                    (() => {
                      const price = selectedVariant?.price ?? selectedVariantValues?.price ?? productDetails?.price;
                      const mrp = selectedVariant?.mrp ?? selectedVariantValues?.mrp ?? productDetails?.mrp;
                      return !price || price === 0
                        ? mrp?.toLocaleString("en-IN") || "N/A"
                        : price?.toLocaleString("en-IN") || "N/A";
                    })()
                  }
                </Typography>

                {
                  (() => {
                    const price = selectedVariant?.price ?? selectedVariantValues?.price ?? productDetails?.price;
                    const mrp = selectedVariant?.mrp ?? selectedVariantValues?.mrp ?? productDetails?.mrp;
                    if (!price || price === 0 || price === mrp) {
                      return null;
                    }
                    return (
                      <Typography
                        variant="body2"
                        sx={{ textDecoration: "line-through", color: grey[500] }}
                        className={"fontclass drawerStrikeThrough"}
                      >
                        &#8377; {mrp?.toLocaleString("en-IN") || "N/A"}
                      </Typography>
                    );
                  })()
                }
              </Box>

              <div
                style={{
                  borderTop: "1px solid #677B8A50",
                  margin: "7px", marginBottom: "0px", width: "100%",
                }}
                className="varient-size-color"
              >
                <VariantList
                  productVariants={
                    productDetails?.additionalInfo?.productVariants
                  }
                  onVariantSelect={onVariantSelect}
                  selectedVariantValues={selectedVariantValues}
                />
              </div>
            </>
          ) : (
            <Typography sx={{ textAlign: "center", mt: 2 }}>
              No product selected
            </Typography>
          )}
        </StyledBox>

        <div className="cart-container">
          {isProductInCart ? (
            <>
              <div className="counter">
                <button disabled={count === 1} onClick={() => decrementHandler()}>
                  <CiCircleMinus />
                </button>
                <div className="counting">{count}</div>
                <button onClick={incrementHandler}
                  disabled={adding}>
                <CiCirclePlus />
              </button>
            </div>

          <button className="add_to_cart_btn" style={{ padding: "8px 20px" }} onClick={handlegoToCart}>
            Go to Cart
          </button>
        </>
        ) : (
        <div className="d-flex flex-column align-items-center justify-content-center w-100 gap-3 mt-3">
          {isOutOfStock() ? (
            <button className="out-of-stock">Out Of Stock</button>
          ) : (
            <>
            <button
                className="button theme-btn w-100"
                onClick={buyItNow}
              >
                Buy now
              </button>
              <button
                className="button theme-btn-outline "
                disabled={adding}
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>

              
            </>
          )}
        </div>
          )}
      </div>

    </SwipeableDrawer>
    </Root >
  );
};

export default CommonDrawer;